// Libraries
import { Container } from '@chakra-ui/react';
import { PropsWithChildren, ReactElement } from 'react';
//Components
import { RootLayout } from '@layout/index';

/**
 * Represents the base layout component.
 *
 * @component
 * @param {PropsWithChildren} props - The props for the BaseLayout component.
 * @param {React.ReactNode} props.children - The child elements to be rendered inside the layout.
 * @returns {ReactElement} The rendered BaseLayout component.
 */
export const BaseLayout = ({ children }: PropsWithChildren): ReactElement => {
  return (
    <RootLayout>
      <Container display='flex' flexDirection='column' flex='1' as='main' maxW={384} px={{ base: 3, md: 6 }}>
        {children}
      </Container>
    </RootLayout>
  );
};
